import React from 'react';

type BillComparisonIconProps = React.SVGProps<SVGSVGElement>;

const BillComparisonIcon: React.FC<BillComparisonIconProps> = props => {
  return (
    <svg
      width={18}
      height={21}
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0673 9.1385H11.202V7.06725H13.273V5.93275H11.202V3.8615H10.0673V5.93275H7.99625V7.06725H10.0673V9.1385ZM7.99625 13.0673H13.273V11.9327H7.99625V13.0673ZM4.7115 17.7307C4.31933 17.7307 3.98092 17.5884 3.69625 17.3038C3.41158 17.0191 3.26925 16.6807 3.26925 16.2885V1.44225C3.26925 1.05008 3.41158 0.711667 3.69625 0.427C3.98092 0.142334 4.31933 0 4.7115 0H12.8923L18 5.10775V16.2885C18 16.6807 17.8577 17.0191 17.573 17.3038C17.2883 17.5884 16.9499 17.7307 16.5578 17.7307H4.7115ZM4.7115 16.596H16.5578C16.6346 16.596 16.7051 16.564 16.7693 16.5C16.8333 16.4358 16.8652 16.3653 16.8652 16.2885V5.59425L12.325 1.13475H4.7115C4.63467 1.13475 4.56417 1.16675 4.5 1.23075C4.436 1.29492 4.404 1.36542 4.404 1.44225V16.2885C4.404 16.3653 4.436 16.4358 4.5 16.5C4.56417 16.564 4.63467 16.596 4.7115 16.596ZM1.44225 21C1.05008 21 0.711667 20.8577 0.427 20.573C0.142333 20.2883 0 19.9499 0 19.5578V5.28475H1.13475V19.5578C1.13475 19.6346 1.16675 19.7051 1.23075 19.7693C1.29492 19.8333 1.36542 19.8652 1.44225 19.8652H12.6902V21H1.44225Z"
        fill="white"
      />
    </svg>
  );
};

export default BillComparisonIcon;
